var map = {
	"./PBR-322-plasmid-1.png": 6868,
	"./PCR_hero.png": 7365,
	"./amplicons.png": 3027,
	"./antibody.png": 4663,
	"./background-dna.jpg": 2379,
	"./black-pointing-right-finger-svgrepo-com.svg": 1631,
	"./color4.png": 9216,
	"./colors.jpg": 1583,
	"./colors.png": 8863,
	"./colors2.png": 4669,
	"./colors3.png": 2164,
	"./credit_card_gear_24dp_2854C5_FILL0_wght400_GRAD0_opsz24.svg": 3859,
	"./dnaforweb.png": 7985,
	"./homeDoublePeak.png": 7664,
	"./homeNewPlasmid.png": 9242,
	"./mutations.png": 4431,
	"./nanopore-image.png": 7161,
	"./order_approve_24dp_2854C5_FILL0_wght400_GRAD0_opsz24.svg": 5797,
	"./pca.png": 299,
	"./pcr.png": 1552,
	"./pcrqc.png": 5848,
	"./plasmidOverlay.png": 6073,
	"./plasmids.png": 6886,
	"./plasmidseq.png": 6052,
	"./pointing-right-finger-svgrepo-com.svg": 3473,
	"./polya.png": 9452,
	"./polyavector.png": 6821,
	"./rca.png": 7669,
	"./version1-plasmidhome.png": 850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4004;